import { StatusMark } from "./StatusMark";
import type { VisitStage } from "./visitsClient";

/**
 * One stage in the flow tracker: a status mark, the stage name, and a "NOW" tag
 * when active. No subtask list, since a stage's tasks are agent bookkeeping
 * (BE-2381).
 */
export const StageRow = ({
  stage,
  stale = false,
}: {
  stage: VisitStage;
  /** Stale visit: the active stage is where work stopped, so it flags. */
  stale?: boolean;
}) => {
  return (
    <div className="mb-0.5 flex items-center gap-2.5 px-1 py-1.5">
      <StatusMark status={stage.status} stale={stale} />
      <span
        className={`min-w-0 flex-1 truncate text-sm ${
          stage.status === "active"
            ? "font-semibold text-ink"
            : stage.status === "done"
              ? "font-medium text-ink-body"
              : stage.status === "skipped"
                ? "text-annotation line-through"
                : "text-annotation"
        }`}
      >
        {stage.name}
      </span>
      {stage.status === "active" && (
        // Not a kit Tag: a Tag states a fact and its tone map refuses status
        // ink on purpose, so a `working` tone there would become the way to
        // say a status without its marker. Working ink on a border and a word
        // is what DESIGN.md allows a bare `ink-*` to do.
        <span
          className={`ml-auto shrink-0 rounded-full border px-1.5 text-annotation-caps ${
            stale
              ? "border-ink-flag text-ink-flag"
              : "border-ink-working text-ink-working"
          }`}
        >
          NOW
        </span>
      )}
    </div>
  );
};
